import * as Yup from "yup";

export const forgotpasswordSchema = Yup.object({
  Username: Yup.string().required("Please enter your username."),
 
});
